import { configureStore } from '@reduxjs/toolkit';
import { dialogSlice, turnAdminSlice } from './slices';

export const store = configureStore({
  reducer: {
    dialog: dialogSlice,
    turnAdmin: turnAdminSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
